var render = function () {
  var _vm$policyDetails, _vm$policyDetails2, _vm$policyDetails3, _vm$policyDetails4, _vm$policyDetails5, _vm$policyDetails6, _vm$policyDetails7;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "4",
      "cols": "12"
    }
  }, [_c('b-card', [_c('b-card-text', [_c('p', {
    staticClass: "text-uppercase custom-text-disabled"
  }, [_vm._v(" Hourly Work Policy Details ")]), _c('b-list-group', {
    attrs: {
      "flush": ""
    }
  }, [_c('b-list-group-item', [_c('div', {
    staticClass: "text-base"
  }, [_vm._v(" Title: "), _c('span', {
    staticClass: "text-body-2 font-weight-bold"
  }, [_vm._v(_vm._s((_vm$policyDetails = _vm.policyDetails) === null || _vm$policyDetails === void 0 ? void 0 : _vm$policyDetails.title))])])]), _c('b-list-group-item', [_c('div', {
    staticClass: "text-base font-weight-semibold"
  }, [_vm._v(" Duration (in days): "), _c('span', {
    staticClass: "text-body-2 font-weight-bold"
  }, [_vm._v(" " + _vm._s((_vm$policyDetails2 = _vm.policyDetails) === null || _vm$policyDetails2 === void 0 ? void 0 : _vm$policyDetails2.duration_in_days) + " ")])])]), _c('b-list-group-item', [_c('div', {
    staticClass: "text-base"
  }, [_vm._v(" Timer: "), _c('span', {
    staticClass: "text-body-2 font-weight-bold"
  }, [_vm._v(" " + _vm._s((_vm$policyDetails3 = _vm.policyDetails) !== null && _vm$policyDetails3 !== void 0 && _vm$policyDetails3.timer ? "On" : "Off") + " ")])])]), _c('b-list-group-item', [_c('div', {
    staticClass: "text-base"
  }, [_vm._v(" Start Time: "), _c('span', {
    staticClass: "text-body-2 font-weight-bold"
  }, [_vm._v(_vm._s(_vm.formatFnTableCheckIn((_vm$policyDetails4 = _vm.policyDetails) === null || _vm$policyDetails4 === void 0 ? void 0 : _vm$policyDetails4.start_time)))])])]), _c('b-list-group-item', [_c('div', {
    staticClass: "text-base"
  }, [_vm._v(" End Time: "), _c('span', {
    staticClass: "text-body-2 font-weight-bold"
  }, [_vm._v(_vm._s(_vm.formatFnTableCheckIn((_vm$policyDetails5 = _vm.policyDetails) === null || _vm$policyDetails5 === void 0 ? void 0 : _vm$policyDetails5.end_time)))])])])], 1)], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "lg": "8",
      "cols": "12"
    }
  }, [_c('b-card', [_c('div', [_c('div', {
    staticClass: "custom-search d-flex align-items-center justify-content-end"
  }, [_c('div', {
    staticClass: "d-flex flex-column flex-sm-row align-items-center mb-1 justify-content-around"
  }, [_c('b-form-input', {
    staticClass: "d-inline-block mr-sm-1 mb-1 mb-sm-0",
    attrs: {
      "placeholder": "Search...",
      "type": "text"
    },
    on: {
      "keyup": _vm.onSearch
    },
    model: {
      value: _vm.searchTerm,
      callback: function callback($$v) {
        _vm.searchTerm = $$v;
      },
      expression: "searchTerm"
    }
  }), _vm.$permissionAbility(_vm.PAYROLL_POLICY_ASSIGN, _vm.permissions) ? [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "flex-shrink-0",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.showPolicyAssignModal
    }
  }, [_vm._v(" Add Member ")])] : _vm._e()], 2)]), _c('vue-good-table', {
    attrs: {
      "style-class": "vgt-table table-custom-style striped",
      "line-numbers": false,
      "mode": "remote",
      "total-rows": _vm.totalRecords,
      "is-loading": _vm.isLoading,
      "rows": _vm.rows,
      "sort-options": {
        enabled: true,
        multipleColumns: true,
        initialSortBy: [{
          field: 'created_at',
          type: 'desc'
        }]
      },
      "columns": _vm.columns,
      "pagination-options": {
        enabled: true,
        perPage: _vm.pageLength
      }
    },
    on: {
      "update:isLoading": function updateIsLoading($event) {
        _vm.isLoading = $event;
      },
      "update:is-loading": function updateIsLoading($event) {
        _vm.isLoading = $event;
      },
      "on-page-change": _vm.onPageChange,
      "on-sort-change": _vm.onSortChange,
      "on-column-filter": _vm.onColumnFilter,
      "on-per-page-change": _vm.onPerPageChange
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function fn(props) {
        var _props$row, _props$row$user;
        return [props.column.field === 'format_user_info' ? _c('span', [_c('UserCard', {
          attrs: {
            "user": props === null || props === void 0 ? void 0 : (_props$row = props.row) === null || _props$row === void 0 ? void 0 : (_props$row$user = _props$row.user) === null || _props$row$user === void 0 ? void 0 : _props$row$user.data
          }
        })], 1) : _vm._e(), props.column.field === 'action' ? _c('span', [_c('span', [_c('div', {
          staticClass: "cursor-pointer",
          on: {
            "click": function click($event) {
              return _vm.onShow(props.row);
            }
          }
        }, [_c('feather-icon', {
          staticClass: "mr-50",
          attrs: {
            "icon": "Edit2Icon"
          }
        })], 1)])]) : _c('span', [_vm._v(" " + _vm._s(props.formattedRow[props.column.field]) + " ")])];
      }
    }, {
      key: "pagination-bottom",
      fn: function fn(props) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between flex-wrap"
        }, [_c('div', {
          staticClass: "d-flex align-items-center mb-0 mt-1"
        }, [_c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(" Showing 1 to ")]), _c('b-form-select', {
          staticClass: "mx-1",
          attrs: {
            "options": ['10', '25', '50', '100', '500']
          },
          on: {
            "input": function input(value) {
              return props.perPageChanged({
                currentPerPage: value
              });
            }
          },
          model: {
            value: _vm.pageLength,
            callback: function callback($$v) {
              _vm.pageLength = $$v;
            },
            expression: "pageLength"
          }
        }), _c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(" of " + _vm._s(props.total) + " entries ")])], 1), _c('div', [_c('b-pagination', {
          staticClass: "mt-1 mb-0",
          attrs: {
            "value": 1,
            "total-rows": props.total,
            "per-page": _vm.pageLength,
            "first-number": "",
            "last-number": "",
            "align": "right",
            "prev-class": "prev-item",
            "next-class": "next-item"
          },
          on: {
            "input": function input(value) {
              return props.pageChanged({
                currentPage: value
              });
            }
          },
          scopedSlots: _vm._u([{
            key: "prev-text",
            fn: function fn() {
              return [_c('feather-icon', {
                attrs: {
                  "icon": "ChevronLeftIcon",
                  "size": "18"
                }
              })];
            },
            proxy: true
          }, {
            key: "next-text",
            fn: function fn() {
              return [_c('feather-icon', {
                attrs: {
                  "icon": "ChevronRightIcon",
                  "size": "18"
                }
              })];
            },
            proxy: true
          }], null, true)
        })], 1)])];
      }
    }])
  })], 1)])], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [(_vm$policyDetails6 = _vm.policyDetails) !== null && _vm$policyDetails6 !== void 0 && _vm$policyDetails6.id ? _c('PayslipHourlyPolicyRules', {
    attrs: {
      "policy": (_vm$policyDetails7 = _vm.policyDetails) === null || _vm$policyDetails7 === void 0 ? void 0 : _vm$policyDetails7.id
    }
  }) : _vm._e()], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "modal-policy-assign-user",
      "centered": "",
      "title": "Add Member To Policy",
      "hide-footer": "",
      "no-close-on-backdrop": ""
    },
    on: {
      "hidden": _vm.hiddenPolicyAssignModal
    }
  }, [_c('validation-observer', {
    ref: "assignUserPolicy"
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.assignUserPolicyForm($event);
      }
    }
  }, [_c('UserAssignPolicyForm', {
    attrs: {
      "salary-type": 'hourly'
    },
    on: {
      "userAssignFromDataEvent": _vm.handleUserAssignFromData
    }
  }), _c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Start Date",
      "label-for": "start_date"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "start date",
      "vid": "start_date",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var errors = _ref.errors;
        return [_c('flat-pickr', {
          staticClass: "form-control",
          attrs: {
            "id": "start_date",
            "placeholder": "Select Date",
            "state": errors.length > 0 ? false : null,
            "config": _vm.datePickerConfig
          },
          model: {
            value: _vm.start_date,
            callback: function callback($$v) {
              _vm.start_date = $$v;
            },
            expression: "start_date"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _vm.isUserPolicyAssignFormSubmitLoading ? [_c('b-button', {
    staticClass: "float-right",
    attrs: {
      "variant": "primary",
      "disabled": ""
    }
  }, [_c('b-spinner', {
    attrs: {
      "small": ""
    }
  }), _vm._v(" Loading... ")], 1)] : [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "float-right",
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v(" Assign ")])]], 2)], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "modal-hourly-policy-assign-form",
      "centered": "",
      "title": 'Update User Assign',
      "hide-footer": "",
      "no-close-on-backdrop": ""
    },
    on: {
      "hidden": _vm.hiddenModal
    }
  }, [_c('validation-observer', {
    ref: "policyForm"
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.submit($event);
      }
    }
  }, [_c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Next Payslip Generate Date",
      "label-for": "next_date"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "next generate date",
      "vid": "next_date",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var errors = _ref2.errors;
        return [_c('flat-pickr', {
          staticClass: "form-control",
          attrs: {
            "id": "dob",
            "placeholder": "Select Date",
            "state": errors.length > 0 ? false : null,
            "config": _vm.datePickerConfig
          },
          model: {
            value: _vm.next_generated_date,
            callback: function callback($$v) {
              _vm.next_generated_date = $$v;
            },
            expression: "next_generated_date"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _vm.isLoading ? [_c('b-button', {
    staticClass: "float-right",
    attrs: {
      "variant": "primary",
      "disabled": ""
    }
  }, [_c('b-spinner', {
    attrs: {
      "small": ""
    }
  }), _vm._v(" Loading... ")], 1)] : [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "float-right",
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v(" Submit ")])]], 2)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }